import BaseForm from "../form";
import EquipmentApi from "../../api/references/equipment";
import {FormItem} from "@vkontakte/vkui";
import SelectObject from "../../assets/SelectObject";
import React from "react";



class EquipmentForm extends BaseForm {

    onFieldChange = (e, fieldName) => {

        const {fields} = this.state
        const field = fields[fieldName]

        if (!field) return
        if (e.uid) {
            field.value = e
        } else if (e.currentTarget.type == 'checkbox') {
            field.value = e.currentTarget.checked ? 1 : 0
        } else {
            field.value = e.currentTarget.value
        }
        fields[fieldName] = field

        if(fieldName == 'stand_id'){
           window.postMessage('resetDefaultSelected')

            const fieldCollection = fields['collection_id']
            fieldCollection.value = {}
            fields['collection_id'] = fieldCollection
            setTimeout(()=> this.setState({fields}), 500)
        } else {
            this.setState({fields})
        }




    }
    renderSelectObject = (fieldName, field) => {


        let params = ''

        if(fieldName == 'collection_id'){

            const fieldBrand = this.state.fields['stand_id']
            if(fieldBrand.value && fieldBrand.value.uid){
                      params = `stand_id=${fieldBrand.value.uid}`
            }
        }

        return <FormItem top={field.title} bottom={field.error}
                         status={field.error ? 'error' : ''}>
            <SelectObject
                only_btn
                size="s"
                disabled={field.disabled}
                current_user={this.props.current_user}
                app={field.app}
                act={field.act}
                params={params?? ''}
                default={field.value}
                modal_title={field.modal_title}

                selectObject={e => this.onFieldChange(e, fieldName)}
            />
        </FormItem>
    }

    doSave = (item) =>{
        EquipmentApi.save(item).then(result => {
            const {data} = result
            if (data.id) {
                window.postMessage({type: this.props.eventType, value: data})
                window.postMessage({type: 'success', text: 'Данные сохранены', timeout: 1500, hideSpinner: true})
            }
        })
    }
}

export default EquipmentForm